import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const money = (v) => `₹${Number(v || 0).toLocaleString("en-IN")}`;

export default function ApplicatorPayouts() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/applicator/payouts").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <div className="text-gray-500">Loading…</div>;
  const t = data.totals;
  return (
    <div data-testid="applicator-payouts-page">
      <h1 className="serif-head text-3xl lg:text-4xl mb-6">Payouts</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-8">
        {[["Total Earned", t.total], ["Pending", t.pending], ["Payable", t.payable], ["Paid", t.paid]].map(([l, v]) => (
          <div key={l} className="hair-border bg-white/[0.02] p-5"><p className="errah-label mb-1">{l}</p><p className="font-display text-2xl gold-text">{money(v)}</p></div>
        ))}
      </div>
      <p className="errah-label gold-text mb-3">Payout history</p>
      <div className="hair-border divide-y divide-white/10" data-testid="payout-history">
        {data.payouts.length === 0 && <p className="p-4 text-sm text-gray-600">No payouts yet. Payouts are approved by ERRĀH admin from your payable balance.</p>}
        {data.payouts.map((p) => (
          <div key={p.id} className="p-4 flex items-center justify-between bg-white/[0.02]">
            <div><p className="text-sm">{p.created_at?.slice(0, 10)} · {p.status}</p><p className="text-xs text-gray-500">{p.reference || p.id.slice(0, 12)}</p></div>
            <p className="font-display gold-text">{money(p.amount)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
